/* ==========================================================================
   TSH · Shop the look — lógica
   The Sole Hunters · Tema Tinker (Horizon)
   --------------------------------------------------------------------------
   Custom element <tsh-stories>. Se auto-registra.
   Depende de: assets/tsh-stories.css

   Modelo: una tarjeta = una foto = un producto.
   La activa reproduce con su barra; el resto queda atenuada y desenfocada.
   El carril solo se desplaza cuando la activa llegaría a salir de la vista.
   ========================================================================== */

(function () {
  'use strict';

  if (customElements.get('tsh-stories')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class TshStories extends HTMLElement {

    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      try {
        this.viewport = this.querySelector('[data-viewport]');
        this.track    = this.querySelector('[data-track]');
        this.cards    = Array.prototype.slice.call(this.querySelectorAll('[data-story]'));
        this.dots     = Array.prototype.slice.call(this.querySelectorAll('[data-dot]'));
        this.prevBtn  = this.querySelector('[data-nav="prev"]');
        this.nextBtn  = this.querySelector('[data-nav="next"]');

        if (!this.track || !this.cards.length) return;

        this.duration = parseInt(this.dataset.duration, 10) || 4000;
        this.loop     = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay !== 'false';
        this.openCart = this.dataset.openCart === 'true';

        this.index   = 0;      // tarjeta activa
        this.offset  = 0;      // primera tarjeta visible
        this.perView = 1;
        this.step    = 0;      // ancho de tarjeta + hueco
        this.paused  = false;
        this.elapsed = 0;
        this.last    = 0;
        this.raf     = null;
        this.visible = false;

        this.measure();
        this.bindDrag();
        this.bindControls();
        this.bindProducts();
        this.observe();

        this.setActive(0, true);

        var self = this;
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            self.measure();
            self.slideTo(self.offset, true);
          }, 160);
        }, { passive: true });
      } catch (err) {
        console.error('[TSH stories] init', err);
      }
    }

    /* ======================================================================
       MEDICIÓN
       ====================================================================== */
    measure() {
      var card = this.cards[0];
      if (!card) return;

      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      var w = card.getBoundingClientRect().width;

      this.step = w + gap;
      // Cuántas caben enteras en el visor
      this.perView = Math.max(1, Math.floor((this.viewport.clientWidth + gap) / this.step));
      this.maxOffset = Math.max(0, this.cards.length - this.perView);
    }

    /* ======================================================================
       DESPLAZAMIENTO DEL CARRIL
       Solo se mueve cuando la activa saldría de la zona visible.
       ====================================================================== */
    slideTo(offset, instant) {
      this.offset = Math.max(0, Math.min(offset, this.maxOffset));

      if (instant) this.track.classList.add('no-anim');
      this.track.style.transform = 'translate3d(' + (-this.offset * this.step) + 'px, 0, 0)';
      if (instant) {
        void this.track.offsetWidth;   // fuerza el repintado antes de reactivar
        this.track.classList.remove('no-anim');
      }

      this.paintNav();
    }

    /* Asegura que la tarjeta i esté dentro de la ventana visible */
    ensureVisible(i) {
      if (i < this.offset) this.slideTo(i);
      else if (i > this.offset + this.perView - 1) this.slideTo(i - this.perView + 1);
    }

    paintNav() {
      if (this.prevBtn) this.prevBtn.disabled = this.offset <= 0 && !this.loop;
      if (this.nextBtn) this.nextBtn.disabled = this.offset >= this.maxOffset && !this.loop;
    }

    /* ======================================================================
       TARJETA ACTIVA
       ====================================================================== */
    setActive(i, instant) {
      var self = this;

      if (i >= this.cards.length) {
        if (!this.loop) { this.stop(); return; }
        i = 0;
        this.slideTo(0);
      }
      if (i < 0) i = 0;

      this.index = i;

      this.cards.forEach(function (c, n) {
        c.classList.toggle('is-active', n === i);
        var fill = c.querySelector('[data-fill]');
        if (fill && n !== i) fill.style.width = '0%';
      });

      this.dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
      });

      this.ensureVisible(i);

      // Precarga la siguiente: al avanzar ya está en caché
      var next = this.cards[i + 1];
      if (next) {
        var img = next.querySelector('img[data-src]');
        if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      }

      if (this.autoplay) this.restart();
    }

    next() {
      if (this.index < this.cards.length - 1) this.setActive(this.index + 1);
      else if (this.loop) this.setActive(0);
      else this.stop();
    }

    prev() {
      if (this.index > 0) this.setActive(this.index - 1);
      else this.restart();
    }

    /* ======================================================================
       TEMPORIZADOR
       El progreso se pinta frame a frame: al pausar se congela donde está.
       ====================================================================== */
    restart() {
      this.stop();
      this.elapsed = 0;
      this.last = 0;
      if (!this.visible) return;
      var self = this;
      this.raf = requestAnimationFrame(function (t) { self.tick(t); });
    }

    stop() {
      if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
    }

    tick(now) {
      var self = this;
      if (!this.last) this.last = now;
      var dt = now - this.last;
      this.last = now;

      if (!this.paused) this.elapsed += dt;

      var pct = Math.min(100, (this.elapsed / this.duration) * 100);
      var card = this.cards[this.index];
      var fill = card && card.querySelector('[data-fill]');
      if (fill) fill.style.width = pct + '%';

      if (pct >= 100) { this.next(); return; }

      this.raf = requestAnimationFrame(function (t) { self.tick(t); });
    }

    pause(on) {
      this.paused = on;
    }

    /* Solo reproducimos con la sección a la vista: no gastamos batería */
    observe() {
      var self = this;
      if (!('IntersectionObserver' in window)) { this.visible = true; this.restart(); return; }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          self.visible = e.isIntersecting;
          if (e.isIntersecting) {
            if (!self.raf && self.autoplay) { self.last = 0; self.raf = requestAnimationFrame(function (t) { self.tick(t); }); }
          } else {
            self.stop();
          }
        });
      }, { threshold: 0.25 }).observe(this);

      document.addEventListener('visibilitychange', function () {
        self.pause(document.hidden);
      });
    }

    /* ======================================================================
       ARRASTRE
       ====================================================================== */
    bindDrag() {
      var self = this;
      var vp = this.viewport;
      if (!vp) return;

      var down = false, startX = 0, startY = 0, baseX = 0, moved = 0, axis = null;

      vp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true;
        moved = 0;
        axis = null;
        startX = e.clientX;
        startY = e.clientY;
        baseX = -self.offset * self.step;
        self.pause(true);
        self.track.classList.add('no-anim');
        if (e.pointerType === 'mouse') {
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });

      vp.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        // Decidimos el eje una sola vez: si es vertical, soltamos el gesto
        if (!axis && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'y') { down = false; self.release(); return; }
        }
        if (axis !== 'x') return;

        moved = Math.abs(dx);
        if (moved > 5) vp.classList.add('is-dragging');

        if (e.pointerType === 'mouse') e.preventDefault();

        // Resistencia en los extremos
        var x = baseX + dx;
        var min = -self.maxOffset * self.step;
        if (x > 0) x = x * 0.35;
        else if (x < min) x = min + (x - min) * 0.35;

        self.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      });

      function end(e) {
        if (!down) { return; }
        down = false;
        try { vp.releasePointerCapture(e.pointerId); } catch (err) {}

        var dx = e.clientX - startX;
        self.track.classList.remove('no-anim');

        // Un desplazamiento de más de un tercio de tarjeta cambia de posición
        var jumped = Math.round(-dx / self.step);
        if (Math.abs(dx) > self.step * 0.32 && jumped === 0) jumped = dx < 0 ? 1 : -1;

        var target = self.offset + jumped;
        self.slideTo(target);

        // La activa pasa a ser la primera visible tras arrastrar
        if (Math.abs(dx) > 8) self.setActive(self.offset);

        setTimeout(function () { vp.classList.remove('is-dragging'); }, 60);
        self.release();
      }

      vp.addEventListener('pointerup', end);
      vp.addEventListener('pointercancel', function (e) { down = false; self.release(); });
      vp.addEventListener('pointerleave', function (e) { if (down) end(e); });

      // En táctil dejamos el scroll vertical al navegador
      vp.addEventListener('touchmove', function (e) {
        if (axis === 'x') e.preventDefault();
      }, { passive: false });
    }

    release() {
      this.track.classList.remove('no-anim');
      this.pause(false);
    }

    /* ======================================================================
       CONTROLES: flechas, puntos, hover, teclado
       ====================================================================== */
    bindControls() {
      var self = this;

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.prev(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); });

      this.dots.forEach(function (d, n) {
        d.addEventListener('click', function () { self.setActive(n); });
      });

      // Clic en una tarjeta inactiva la activa
      this.cards.forEach(function (card, n) {
        card.addEventListener('click', function (e) {
          if (self.viewport.classList.contains('is-dragging')) return;
          if (e.target.closest('[data-buy], [data-plink]')) return;
          if (n !== self.index) { self.setActive(n); return; }
          // Ya activa: alterna pausa
          self.pause(!self.paused);
        });
      });

      // Hover en escritorio: pausa
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('mouseenter', function () { self.pause(true); });
        this.addEventListener('mouseleave', function () { self.pause(false); });
      }

      // Mantener pulsado en táctil: pausa
      var hold = null, held = false;
      this.cards.forEach(function (card) {
        card.addEventListener('touchstart', function () {
          held = false;
          hold = setTimeout(function () { held = true; self.pause(true); }, 240);
        }, { passive: true });

        card.addEventListener('touchend', function () {
          clearTimeout(hold);
          if (held) { self.pause(false); held = false; }
        }, { passive: true });
      });

      // Teclado
      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); }
        else if (e.key === ' ') { e.preventDefault(); self.pause(!self.paused); }
      });

      // El foco por teclado activa la tarjeta
      this.cards.forEach(function (card, n) {
        card.addEventListener('focusin', function () {
          if (n !== self.index) self.setActive(n);
        });
      });
    }

    /* ======================================================================
       COMPRA
       ====================================================================== */
    bindProducts() {
      var self = this;

      this.querySelectorAll('[data-buy]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          // Sin variante única: es un enlace a la ficha
          if (btn.dataset.href) { window.location.href = btn.dataset.href; return; }

          var id = btn.dataset.buy;
          if (!id) return;

          var original = btn.textContent;
          btn.classList.add('is-loading');
          btn.textContent = '···';
          self.pause(true);

          fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          })
            .then(function (res) {
              if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'add'); });
              return res.json();
            })
            .then(function () {
              btn.classList.remove('is-loading');
              btn.classList.add('is-done');
              btn.textContent = 'Añadido ✓';

              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('tsh:cart:dirty', { bubbles: true }));

              if (self.openCart) {
                setTimeout(function () {
                  document.dispatchEvent(new CustomEvent('tsh:cart:open'));
                }, 500);
              }

              setTimeout(function () {
                btn.classList.remove('is-done');
                btn.textContent = original;
                self.pause(false);
              }, 1800);
            })
            .catch(function (err) {
              console.error('[TSH stories] add', err);
              btn.classList.remove('is-loading');
              btn.textContent = 'Error';
              setTimeout(function () {
                btn.textContent = original;
                self.pause(false);
              }, 1800);
            });
        });
      });

      // El panel no debe activar ni pausar al pulsarlo
      this.querySelectorAll('[data-panel]').forEach(function (p) {
        p.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
      });
    }
  }

  customElements.define('tsh-stories', TshStories);
})();